// @flow

import React from "react";

import CommitmentListContainer from "./CommitmentListContainer";

const ReportListContainer = () => (
  <CommitmentListContainer reportListing={true} />
);

export default ReportListContainer;



// WEBPACK FOOTER //
// ./src/components/commitmentList/ReportListContainer.js